import Divider from '@cobliteam/ui/components/Divider';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.svg';

const LogoComponent = () => {
  return (
    <>
      <Link to='/'>
        <img src={logo} alt='Cobli' className='size-6 shrink-0' />
      </Link>
      <Divider orientation='vertical' className='mx-1 h-8' />
    </>
  );
};

export default LogoComponent;
